"use strict";
//
// Copyright © 2025 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFileStorage = createFileStorage;
const datalake_1 = require("./datalake");
const front_1 = require("./front");
const hulylake_1 = require("./hulylake");
/** @public */
function createFileStorage(config) {
    const { uploadUrl, datalakeUrl, hulylakeUrl } = config;
    if (datalakeUrl !== undefined && datalakeUrl !== '') {
        console.debug('Using Datalake storage');
        return new datalake_1.DatalakeStorage(datalakeUrl);
    }
    if (hulylakeUrl !== undefined && hulylakeUrl !== '') {
        console.debug('Using Hulylake storage');
        return new hulylake_1.HulylakeStorage(hulylakeUrl);
    }
    console.debug('Using Front storage');
    return new front_1.FrontStorage(uploadUrl);
}
//# sourceMappingURL=index.js.map